module.exports = __webpack_public_path__ + "img/114650.58aa5c98.svg";